import { Navigate, Outlet } from 'react-router';
import { useMultiSiteAccess } from '../../hooks/my-sites/use-multi-site-access';
import { isGuardQuerySettling } from './guard-query-state';

/**
 * Gates the "Le mie sedi" tree on the backend's own access signal
 * (`GET /my-sites/access`): >=2 sedi dove l'utente è Owner/Manager. A user
 * demoted to a single site (or none) loses the nav entry AND a direct deep
 * link redirects home — mirrors `ConsultantGuard` 1:1.
 */
export function MultiSiteGuard() {
  const { hasMultiSiteAccess, isPending, fetchStatus } = useMultiSiteAccess();

  if (isGuardQuerySettling({ isPending, fetchStatus })) {
    return null;
  }

  if (!hasMultiSiteAccess) {
    return <Navigate to="/home" replace />;
  }

  return <Outlet />;
}
